import { useState } from "react";

const useEquityAccountSettings = (findAccountMapping) => {
  const [equityAccountMapping, setEquityAccountMapping] = useState({
    owners_capital_account:
      findAccountMapping("owners_capital_account")?.chart_account?.id || "",
    owners_drawing_account:
      findAccountMapping("owners_drawing_account")?.chart_account?.id || "",
    retained_earnings_account:
      findAccountMapping("retained_earnings_account")?.chart_account?.id || "",
  });

  return {
    equityAccountMapping,
    setEquityAccountMapping,
  };
};

export default useEquityAccountSettings;
